
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as _91slug_933DatxxqP7JhCXIhbiyS0mAPgHyk0opep793_M6qE2KUMeta } from "/opt/build/repo/pages/[slug].vue?macro=true";
import { default as indexbf9GgBYlDr166merohaW6l54mGuIZ0Wi0Swawj1_9rYMeta } from "/opt/build/repo/pages/blog/index.vue?macro=true";
import { default as contact_45usDylsu0wsCPrptza2TpzW3QUBmXx5p_LARp9bSMQYgw8Meta } from "/opt/build/repo/pages/contact-us.vue?macro=true";
import { default as _91slug_93__45dzJBGpTw0AUSJ7kjWIfsjpDeiJPPe_Cc5rSf34msQMeta } from "/opt/build/repo/pages/blog/[slug].vue?macro=true";
import { default as junojournalPG4aSkBTp8zfK07kfPfF0WXo_k7VawWIhv0dXdHO1lkMeta } from "/opt/build/repo/pages/junojournal.vue?macro=true";
import { default as privacy_45policyPl1ixjl54PV0rmR_45TVWtLEI_4n7GqlEsEe__45AeHGvHsMeta } from "/opt/build/repo/pages/privacy-policy.vue?macro=true";
import { default as terms_45conditionspyw7uMp40A8YQ7MtZc_45CZniCgymXg4jTCLTNq2lO744Meta } from "/opt/build/repo/pages/terms-conditions.vue?macro=true";
import { default as indexwzhVqxHRWeynTdfUtcJ5y5N3cFcM_45URs_45EkX3UqTJbYMeta } from "/opt/build/repo/pages/birth-stories/index.vue?macro=true";
import { default as _91slug_93YoKHk2BkbqzU9XPldWHUv_u4eTm9mStmizxXuYz9vGEMeta } from "/opt/build/repo/pages/birth-stories/[slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/opt/build/repo/pages/[slug].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/opt/build/repo/pages/blog/index.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/opt/build/repo/pages/contact-us.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/opt/build/repo/pages/blog/[slug].vue")
  },
  {
    name: "junojournal",
    path: "/junojournal",
    component: () => import("/opt/build/repo/pages/junojournal.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/opt/build/repo/pages/privacy-policy.vue")
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    component: () => import("/opt/build/repo/pages/terms-conditions.vue")
  },
  {
    name: "birth-stories",
    path: "/birth-stories",
    component: () => import("/opt/build/repo/pages/birth-stories/index.vue")
  },
  {
    name: "birth-stories-slug",
    path: "/birth-stories/:slug()",
    component: () => import("/opt/build/repo/pages/birth-stories/[slug].vue")
  }
]